import { render, staticRenderFns } from "./newsAdd.vue?vue&type=template&id=66514841&scoped=true"
import script from "./newsAdd.vue?vue&type=script&lang=js"
export * from "./newsAdd.vue?vue&type=script&lang=js"
import style0 from "./newsAdd.vue?vue&type=style&index=0&id=66514841&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66514841",
  null
  
)

export default component.exports